import React from "react";
import { useResolveTransactionMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import SelectInput from "../../../Common/components/select-input";
import TextInput from "../../../Common/components/text-input";

const TechSupportResolutionModal = ({ showTechSupportResolutionModal, onHide, details, tableRef }) => {

    const [
        resolveTransaction,
        {
          isLoading: isUpdating
        }, // This is the mutation trigger
    
      ] = useResolveTransactionMutation()
    /* Resolve Transaction */
    const onSubmit = (values) => {
        resolveTransaction({
            autoId: details?.autoId,
            comment: details?.comment,
            status: details?.status,
            flaggedId: details?.flaggedId,
            ...values,
        })
            .unwrap()
            .then(() => {
                tableRef.current.refresh();
                cogoToast.success("Resolve Transaction Action Created Successfully");
                onHide();
            });
    };

    return (
        <Modal
            show={showTechSupportResolutionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={{
                    resolutionType:  "",
                    resolutionComment:  "",
                }}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Resolve Transaction Modal
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                            <FormLayout.Row>
                                <SelectInput
                                    label="Resolution Type*"
                                    name="resolutionType"
                                    options={["tech_resolved"]}
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Comment"
                                    name="resolutionComment"
                                />
                            </FormLayout.Row>

                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                disabled={isUpdating}
                                className="btn btn-light btn-elevate px-4"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isUpdating}
                                className="btn btn-primary btn-elevate px-4 ml-4"
                            >
                                Submit
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default TechSupportResolutionModal;
